// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\GiftcardStatsResponse

export type GiftcardStatsApiResponse = {
	sold: number;
	income: number;
	remaining: number;
};

export type GiftcardStats = {
	sold: number;
	income: number;
	remaining: number;
};

export function hydrateGiftcardStats(data: GiftcardStatsApiResponse): GiftcardStats {
	return { ...data };
}